import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';

import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { LoadContractPaymentTermAction } from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/contracts.actions';
import { getOpenPlatformContractsBalance } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/contracts.selectors';
import { generateAddedValueFormName } from '@ordersnproducts/modules/order-builder/modules/rms-specification/helpers/form-added-value-name-generator';

@Injectable()
export class SetPaymentTermOpenPlatformCommandService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup): void {
    if (value) {
      formGroup.get(generateAddedValueFormName(0)) && formGroup.get(generateAddedValueFormName(0)).setValue(undefined);
      this.store
        .select(getOpenPlatformContractsBalance)
        .pipe()
        .subscribe((contractsBalance) => {
          const contractBalance = contractsBalance[value];
          if (!!contractBalance) {
            this.store.dispatch(
              new LoadContractPaymentTermAction([
                {
                  paymentTermCode: contractBalance[0].paymentTermCode,
                  paymentTermDesc: contractBalance[0].paymentTermDesc,
                },
              ]),
            );
          }
        });
    }
  }
}
